import { Card, Box, styled } from '@mui/material'

export const ProfileCard = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.palette.border.primary}`,
  borderRadius: 24,
  padding: theme.spacing(3),
  boxShadow: 'none',
  '& .MuiPaper-root': {
    boxShadow: 'none',
    padding: 0
  }
}))

export const InfoCard = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.border.primary}`,
  borderRadius: 24,
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.primary,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 12
}))

export const getCrownColor = (user, theme) => {
  if (user.admin && user?.roles?.admin_roles) {
    return theme.palette.warning.main
  }
  if (user.admin) {
    return theme.palette.primary.main
  }
  if (!user.admin && user?.roles?.admin_roles && user?.roles?.admin_contact) {
    return theme.palette.success.main
  }
  if (!user.admin && user?.roles?.admin_contact && !user?.roles?.admin_roles) {
    return theme.palette.error.main
  }
  return '#FFB800'
}
